var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center mt-10 mb-5"},[_c('div',{staticClass:"col-md-4 text-center"},[_c('h1',{staticClass:"playfair-display"},[_vm._v("Contact Us")]),_c('p',{staticClass:"fw-bold"},[_vm._v(" 054-566-1775 / 055-516-2374 "),_c('br'),_vm._v(" hello@thejeansshopgh.com ")])])])
}]

export { render, staticRenderFns }